/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
import { PhoneNumberTypeSchema } from '../enums/PhoneNumberType.schema';
import { PhoneNumberTelephonySchema } from '../enums/PhoneNumberTelephony.schema';
const baseSchema = z.object({
    type: PhoneNumberTypeSchema,
    telephony: PhoneNumberTelephonySchema,
    phoneNumber: z.string().regex(new RegExp("^\\+[1-9]\\d{1,14}$"), { message: "Please enter a valid phone number with country code" }),
    verifiedAt: z.coerce.date().nullish(),
    verifiedBy: z.string().nullish(),
}
).strict();
export const PhoneNumberSchema = baseSchema;
